export default "__VITE_ASSET__B_qAx4sL__"